import { FilterClickable } from "@/common/components/Filter/models/FilterType";

export const mapFilterClickableToString = (filterClickable: FilterClickable) =>
  filterClickable.name;
